import React from 'react';
import {ImmersiveHeader, ImmersiveHeaderProps} from './ImmersiveHeader';
import {LocalVideoOptionsArray} from '../../../types/background.types';
import {CmsComponentMapper} from '../../elements/cms/CmsComponentMapper';
import styled from 'styled-components';
import {isValidMediaOptions} from '../../../utils';

type ImmersiveHeaderPropsOmit = Omit<ImmersiveHeaderProps, 'mediaOptions'>;
export interface ImmersiveHeaderSectionProps extends ImmersiveHeaderPropsOmit {
    mediaOptions?: LocalVideoOptionsArray;
}

const Styled = styled.div`
    background: ${(p) => p.theme.palette.background.default};
    color: ${(p) => p.theme.palette.text.primary};
`;

export const ImmersiveHeaderSection = ({
    mediaOptions,
    ...rest
}: ImmersiveHeaderSectionProps): JSX.Element | null => {
    if (!isValidMediaOptions(mediaOptions)) return null;
    return (
        <Styled>
            <CmsComponentMapper
                dynamicPageDataArray={mediaOptions}
                propKey="mediaOptions"
                elementMapping={{
                    htmlVideo: <ImmersiveHeader {...rest} />,
                    image: <ImmersiveHeader {...rest} />
                }}
            />
        </Styled>
    );
};
